import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'un-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.less'],
  standalone: false,
})
export class CarouselComponent implements AfterContentInit {
  @Input() scrollPx = 150;
  @ViewChild('el', {
    static: true,
  })
  section: ElementRef;
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    this.cdr.detectChanges();
  }
  scrollLeft() {
    this.section.nativeElement.scrollLeft -= this.scrollPx;
  }

  scrollRight() {
    this.section.nativeElement.scrollLeft += this.scrollPx;
  }
}
